module.exports = __webpack_public_path__ + "static/media/messageActive.302e0541.svg";